import { useAppointmentTypeSelector } from './useAsyncSelector';
import { useSelector } from 'src/store';
import { isPaymentRequired } from 'src/utils/appointmentTypes';

export function useShouldHideCloseButton() {
    const { data: appointmentType } = useAppointmentTypeSelector();
    const paymentStatus = useSelector((state) => state.bookingFlow.paymentStatus);
    const reservedBookingId = useSelector((state) => state.appointment.reservedBooking?.appointment_id);

    return (
        !!reservedBookingId &&
        (appointmentType ? !isPaymentRequired(appointmentType) || paymentStatus === 'COMPLETED' : true)
    );
}
